function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownArrowLogin = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 15,
  viewBox: "0 0 25 15",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M2 0h21v15H2Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#596069",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.125 1.125 7.5 7.5l6.375-6.375",
  style: {
    fillRule: "nonzero",
    fill: "#596069",
    fillOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fff",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  },
  transform: "translate(5 3)"
}));
export { SvgDownArrowLogin as ReactComponent };
export default __webpack_public_path__ + "assets/images/downArrowLogin.svg";